import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

export const Help = styled.div`
  z-index: 2000;
  background: white;
  position: absolute;
  right: 4px;
  top: 0;
  margin-top: 10px;
  padding: 15px;
  font-size: 12px;
  border-radius: 5px;
  display: inline-block;
  box-shadow: 1px 2px 4px 0 rgb(0 0 0 / 20%);

  ${breakpoint('tablet')`
        width: 75%;
    `};

  ${breakpoint('desktop')`
        width: 75%;
    `};

  ${breakpoint('mobile')`
        width: 100%
    `};
`;

export const StyledParaHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;

export const StyledPara = styled.p`
  font-size: 13px;
  font-weight: 100;
  text-align: left;
`;

export const Title = styled.div`
  font-size: 1.1em;
  font-weight: 600;
`;

export const Close = styled.div`
  color: #979797;
  font-size: 16px;
  cursor: pointer;
`;

export const ModalMask = styled.div`
  position: fixed;
  inset: 0;
  margin: 0;
  opacity: var(--modal-light-opacity, 0.1);
  z-index: 70;
  background-color: rgb(0 0 0);
  background-color: var(--model-background, rgb(0 0 0));

  & + div {
    z-index: 71;
  }
`;

export const IconWrapper = styled.div`
  display: inline-block;
  font-size: 1.25em;
  cursor: pointer;
  margin: 0 5px;
`;
